import {
    BASE_URL, 
    DELETE, 
    DELETE_QUICK_LINK, 
    PATCH, 
    POST,
    QUICK_LINK,
  } from "../constants";
  import { statusParsing, jsonParsing } from "../utils";
  import { getAccessToken } from "../../authActions/authActions";
  
  export const addQuickLink = async (payload) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${QUICK_LINK}`;
    return fetch(resource, {
      method: POST,
      headers: {
        "Content-Type": "application/json",
        "userauth": `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
      .then(statusParsing)
      .then(jsonParsing);
  };

  export const editQuickLink = async (payload,id) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${QUICK_LINK}/${id}`;
    return fetch(resource, {
      method: PATCH,
      headers: {
        "Content-Type": "application/json",
        "userauth": `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
      .then(statusParsing)
      .then(jsonParsing);
  };

  export const deleteQuickLink = async (id) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${DELETE_QUICK_LINK}${id}`;
    return fetch(resource, {
      method: DELETE,
      headers: {
        "Content-Type": "application/json",
        "userauth": `Bearer ${token}`
      },
    })
      .then(statusParsing)
      .then(jsonParsing);
  };